import { combineReducers } from '@reduxjs/toolkit';

import usersReducer from './user-management-users.slice';
import rolesReducer from './user-management-roles.slice';
import groupsReducer from './user-management-groups.slice';

const userManagementReducer = combineReducers({
  users: usersReducer,
  roles: rolesReducer,
  groups: groupsReducer,
});

export default userManagementReducer;
